import Helpers from "@/services/helpers";
import { SET_PLAYER_PLAYLIST } from "@/store/mutation-types";

export default {
  name: "state",
  install(ctx) {
    Helpers.mapStore(ctx, {
      playlist: {
        get: "player/playlist",
        set: `player/${SET_PLAYER_PLAYLIST}`
      }
    });

    const listen = function() {
      window.addEventListener("storage", event => {
        if (event.key === "player") {
          try {
            const state = JSON.parse(localStorage.getItem(event.key) || "{}");

            if (state.running && state.id !== this.id) {
              this.pause();
            }
          } catch (error) {
            localStorage.removeItem(event.key);
          }
        }
      });
    };

    const save = function(state = {}) {
      if (this.playlist) {
        state.playlist = {
          tracks: this.playlist.tracks,
          index: this.currentIndex,
          id: this.playlist.id
        };
      } else {
        state.playlist = null;
      }

      localStorage.setItem(
        "player",
        JSON.stringify({
          id: this.id,
          volume: this.volume,
          shuffle: this.shuffle,
          repeat: this.repeat,
          running: false,
          ...state
        })
      );
    };

    const restore = function() {
      try {
        const {
          shuffle = false,
          repeat = "none",
          volume = 50,
          playlist = null
        } = JSON.parse(localStorage.getItem("player"));

        if (playlist) {
          this.mod.queue.add(playlist);
          this.mod.queue.setIndex(playlist.index);
        }

        this.playlist = playlist;
        this.shuffle = shuffle;
        this.repeat = repeat;
        this.mod.volume.set(volume);
      } catch (error) {
        localStorage.removeItem("player");
      }
    };

    return {
      listen: listen.bind(ctx),
      save: save.bind(ctx),
      restore: restore.bind(ctx)
    };
  }
};
